import { createContext, useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLanguageFromPath, localizedPath } from "./routes";
import homeEN from "../content/home/en";
import homeAR from "../content/home/ar";
import homeTR from "../content/home/tr";
import privacyEN from "../content/privacy/en";
import privacyAR from "../content/privacy/ar";
import privacyTR from "../content/privacy/tr";
import aboutEN from "../content/about/en";
import aboutAR from "../content/about/ar";
import aboutTR from "../content/about/tr";

export const LanguageContext = createContext(null);

const DICTS = {
  en: {
    ...homeEN,
    privacy: privacyEN,
    about: aboutEN,
  },
  ar: {
    ...homeAR,
    privacy: privacyAR,
    about: aboutAR,
  },
  tr: {
    ...homeTR,
    privacy: privacyTR,
    about: aboutTR,
  },
};

export default function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = getLanguageFromPath(location.pathname);

  const dir = lang === "ar" ? "rtl" : "ltr";
  const t = DICTS[lang] || DICTS.en;

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const setLang = useCallback(
    (nextLanguage) => {
      if (!DICTS[nextLanguage] || nextLanguage === lang) return;
      navigate({
        pathname: localizedPath(location.pathname, nextLanguage),
        hash: location.hash,
      });
    },
    [lang, location.pathname, location.hash, navigate]
  );

  const value = useMemo(
    () => ({
      lang,
      dir,
      t,
      setLang,
      supported: Object.keys(DICTS),
    }),
    [lang, dir, t, setLang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
